import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { deserializeJsonDotNetDate } from '../utils/utils';

function TimestampWithUTCTooltip({ date, placement="bottom", delayShow=100, delayHide=250 }) {

    if (typeof date == "undefined" || date == null) {
        return ''
    } else if (typeof (date) == typeof ("string")) {
        if (date == "") {
            return ""
        }
        let match = date.match(/\/Date\((\d+)\+\d+\)\//)
        if (match && match[1]) {
            date = deserializeJsonDotNetDate(date)
        } else {
            match = date.match(/^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(\.\d+)?$/)
            if (match) {
                //console.log("Date \"".concat(date).concat("\" is a mangled date time string"))
                date = date.concat("Z")
            }
            match = date.match(/^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(\.\d+)?Z$/)
            if (match) {
                //console.log("Date \"".concat(date).concat("\" is a JS date time string"))
                date = new Date(date)
            } else {
                throw Error("Input parameter is the unparseable string \"".concat(date).concat("\""))
            }

        }
    } else if(false == date instanceof Date){
        throw Error("Received the following input parameter in TimestampWithUTCTooltip constructor:\n".concat(date))
    }

    const renderTooltip = function (props) {
        return (
            <Tooltip{...props}><a>{date.toISOString()} UTC</a></Tooltip>
        )
    }

    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: delayShow, hide: delayHide }}
            overlay={renderTooltip}
        ><a>{date.toLocaleString()}</a></OverlayTrigger>
    )
}

export default TimestampWithUTCTooltip